const bluePalette = {
  main: '#A2D5EB',
  light: '#EBFAFB',
  dark: '#4998BA'
};

export default bluePalette;